import auth from "../../middlewares/auth";
export const settingsLectureCategoryRoute = [
  {
    path: '/settings/lecture/category',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/lecture_category/CategoryList'),
    name: 'settings_lecture_category',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/lecture/category/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/lecture_category/CategoryForm'),
    name: 'settings_lecture_category_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/lecture/category/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/lecture_category/CategoryForm'),
    name: 'settings_lecture_category_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];